import moment from 'moment'

import { MOMENT_FORMATS } from '@/localize.js'

export function formatDate (date, format) {
  const FORMAT_DATE_PATTERNS = {
    ymdw: MOMENT_FORMATS.ddd_MMM_D_YYYY,
    ymd: MOMENT_FORMATS.MMM_D_YYYY,
    md: MOMENT_FORMATS.MMM_D,
    mdy: MOMENT_FORMATS.MM_DD_YYYY,
    mdyhm: `${MOMENT_FORMATS.MM_DD_YYYY} • ${MOMENT_FORMATS.hm_A}`,
    MMMMD: MOMENT_FORMATS.MMMM_D,
    MMMDYYYY: MOMENT_FORMATS.MMM_D_YYYY,
    MMMMDYYYY: MOMENT_FORMATS.MMMM_D_YYYY,
  }

  const momentFormat = FORMAT_DATE_PATTERNS[format]
    || format
    || MOMENT_FORMATS.MMM_D_YYYY

  return date
    ? moment(date).format(momentFormat)
    : moment().format(momentFormat)
}

export function formatDateNice (date) {
  return moment(date).calendar(null, MOMENT_FORMATS.calendar)
}
